// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonSearchSearch_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1215 2.63627C13.4647 4.97941 13.4647 8.7784 11.1215 11.1215C8.7784 13.4647 4.97941 13.4647 2.63627 11.1215C0.29312 8.7784 0.29312 4.97941 2.63627 2.63627C4.97941 0.29312 8.7784 0.29312 11.1215 2.63627ZM9.70733 4.05048C11.2694 5.61258 11.2694 8.14524 9.70733 9.70733C8.14524 11.2694 5.61258 11.2694 4.05048 9.70733C2.48838 8.14524 2.48838 5.61258 4.05048 4.05048C5.61258 2.48838 8.14524 2.48838 9.70733 4.05048Z" class="svg-bg"/>
  <path d="M12.5354 12.5361C12.8538 12.2177 13.1397 11.8792 13.3932 11.5247L15.7174 15.011L15.0103 15.7181L11.524 13.3939C11.8785 13.1404 12.2171 12.8545 12.5354 12.5361Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.092 3.36407C19.6067 6.87879 19.6067 12.5773 16.092 16.092C12.5773 19.6067 6.87879 19.6067 3.36407 16.092C-0.150652 12.5773 -0.150652 6.87879 3.36407 3.36407C6.87879 -0.150652 12.5773 -0.150652 16.092 3.36407ZM14.6778 4.77828C17.4114 7.51195 17.4114 11.9441 14.6778 14.6778C11.9441 17.4114 7.51195 17.4114 4.77828 14.6778C2.04461 11.9441 2.04461 7.51195 4.77828 4.77828C7.51195 2.04461 11.9441 2.04461 14.6778 4.77828ZM22.8091 23.517L16.0803 18.7107C16.5805 18.3561 17.0577 17.9547 17.5058 17.5066C17.9539 17.0585 18.3553 16.5813 18.71 16.0811L23.5162 22.8099L22.8091 23.517Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonSearchSearch is a generated icon component.
 */
let IconCommonSearchSearch = IconCommonSearchSearch_1 = class IconCommonSearchSearch extends IconBaseElement {
    render() {
        return html `${IconCommonSearchSearch_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonSearchSearch.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonSearchSearch = IconCommonSearchSearch_1 = __decorate([
    customElement('zui-icon-common-search-search')
], IconCommonSearchSearch);
export { IconCommonSearchSearch };
